export const captureError = (message: string, error: unknown) => {
  import("@sentry/react")
    .then((Sentry) => {
      Sentry.captureMessage(message, {
        extra: {
          error: error instanceof Error ? error.message : String(error),
        },
        level: "error",
      });
    })
    .catch(() => {
      // Sentry not available, just log to console
      console.error("Failed to get nonce:", error);
    });
};
